import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import translate from "../../../i18n/translate";
import "./style.css";
import { getDiscounts } from "../../../actions/discountsAction";
import Spinner from "../../ui/spinner/Spinner";
import { isArray } from 'lodash';
import { 
  Box, 
  Container, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper,
  Pagination,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";

const Discounts = ({ discounts, getDiscounts, isDarktheme }) => {
  const hide = localStorage.getItem('hide companies')
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [loading, isLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [discountData, setDiscountData] = useState([]);
  const itemsPerPage = 10;

  useEffect(() => {
    document.title = "Seller Points | PhonePlay ";
    isLoading(true)
    getDiscounts()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isArray(discounts) && discounts) {
      let discountsArr = discounts.map((discount) => {
        return {
          company: discount.product,
          id: discount.id,
          discountPer: discount.discount,
          active: discount.active,
          location: discount.location
        }
      })
      if (hide === "true") {
        discountsArr = discountsArr.filter((item) => item.location !== "ISR")
      }

      setDiscountData(discountsArr)
      isLoading(false)
    }
    isLoading(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [discounts])

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const totalPages = Math.ceil(discountData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentPageData = discountData.slice(startIndex, startIndex + itemsPerPage);

  return (
    <Container maxWidth="xl" sx={{ py: { xs: 2, md: 4 }, px: { xs: 1, md: 3 } }}>
      <Box sx={{ 
        background: isDarktheme ? '#2d3748' : 'white',
        borderRadius: 2,
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
        overflow: 'hidden'
      }}>
        {/* Header */}
        <Box sx={{ 
          p: { xs: 2, md: 3 },
          borderBottom: '1px solid',
          borderColor: isDarktheme ? '#4a5568' : '#e2e8f0'
        }}>
          <Typography 
            variant={isMobile ? "h6" : "h5"}
            sx={{ 
              fontWeight: 700,
              color: isDarktheme ? '#f7fafc' : '#1a202c'
            }}
          >
            {translate("Discount Table")}
          </Typography>
        </Box>

        {/* Table */}
        {currentPageData.length !== 0 && (
          <TableContainer component={Paper} elevation={0}>
            <Table 
              sx={{ 
                minWidth: isMobile ? 300 : 650,
                '& .MuiTableCell-root': {
                  fontSize: isMobile ? '0.875rem' : '1rem',
                  padding: isMobile ? '8px' : '16px'
                }
              }}
              size={isMobile ? "small" : "medium"}
            >
              <TableHead>
                <TableRow sx={{ background: isDarktheme ? '#4a5568' : '#f7fafc' }}>
                  <TableCell sx={{ 
                    fontWeight: 600,
                    color: isDarktheme ? '#f7fafc' : '#1a202c'
                  }}>
                    {translate('Provider')}
                  </TableCell>
                  <TableCell sx={{ 
                    fontWeight: 600,
                    color: isDarktheme ? '#f7fafc' : '#1a202c'
                  }}>
                    {translate('discount')}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {currentPageData.map((item, index) => (
                  <TableRow 
                    key={index}
                    sx={{ 
                      '&:hover': { 
                        background: isDarktheme ? '#3a4556' : '#f0f4f8' 
                      },
                      '&:last-child td': { borderBottom: 0 }
                    }}
                  >
                    <TableCell sx={{ color: isDarktheme ? '#e2e8f0' : '#1a202c' }}>
                      {item.company}
                    </TableCell>
                    <TableCell sx={{ 
                      color: isDarktheme ? '#48bb78' : '#10b981',
                      fontWeight: 600
                    }}>
                      %{item.discountPer}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        {/* Pagination */}
        {totalPages > 1 && (
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            p: { xs: 2, md: 3 }
          }}>
            <Pagination 
              count={totalPages}
              page={currentPage}
              onChange={handlePageChange}
              color="primary"
              size={isMobile ? "small" : "medium"}
              sx={{
                '& .MuiPaginationItem-root': {
                  color: isDarktheme ? '#f7fafc' : '#1a202c',
                  fontSize: isMobile ? '0.875rem' : '1rem'
                }
              }}
            />
          </Box>
        )}
      </Box>

      {loading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <Spinner />
        </Box>
      )}
    </Container>
  );
};

const mapStateToProps = (state) => ({
  discounts: state.discounts.discounts,
  isDarktheme: state.darkTheme.isDarktheme
});

export default connect(mapStateToProps, { getDiscounts })(Discounts);

